(function (root, factory) {
    if (typeof define === 'function' && define.amd) {
        // AMD. Register as an anonymous module.
        define(['json-patch/jsonpatch'], factory);
    } else if (typeof module === 'object' && module.exports) {
        // CommonJS
        module.exports = factory(require('json-patch/jsonpatch'));
    } else {
        root.GameDataPatchWorker = factory(root.jsonpatch);
    }
})(this, function (Patcher) {
    'use strict';

    var STRING = 'string';

    function patchHelper (patcher, base, diff) {
        return patcher.apply(base, diff.diff);
    }

    function PatchWorker (instance) {
        this.patcher = Patcher;
        this.patchTarget = instance;
    }

    PatchWorker.prototype.diff = function (update) {
        return {
            diff: this.patcher.diff_main(this.patchTarget.dataString, update)
        };
    };

    PatchWorker.prototype.make_patch = function (update) {
        return {
            patch: this.patcher.patch_make(this.patchTarget.dataString, this.diff(update).diff)
        };
    };

    PatchWorker.prototype.patch = function (diffs) {
        if (typeof diffs === STRING) {
            diffs = JSON.parse(diffs);
        }
        if (!Array.isArray(diffs)) {
            diffs = [diffs];
        }
        var i = 0,
            patched = this.patchTarget.data,
            len = diffs.length;

        for (; i < len; i++) {
            patched = patchHelper(this.patcher, patched, diffs[i]);
        }
        return patched;
    };

    return PatchWorker;
});
